import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { useGlassData } from './useGlassData';

const TintedDesign = ({ value, onChange, id='TintedDesign', label = 'Tinted Design', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedTintedDesign, setSelectedTintedDesign] = useState(defaultValue);
    const { getTintedDesigns, loading, error } = useGlassData();

    const options = getTintedDesigns();

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedTintedDesign(value?.value || '');
    }, [value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && options.length > 0 && !selectedTintedDesign) {
            const defaultOption = options[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedTintedDesign(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, [loading, options]);

    const handleTintedDesignChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedTintedDesign(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    if (error) {
        console.error('Error loading tinted design:', error);
    }

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedTintedDesign}
                onChange={handleTintedDesignChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    options.map(opt => (
                        <option key={opt.id} value={opt.value}>
                            {selectedTintedDesign === opt.value ? `${opt.label} ✔` : opt.label}
                        </option>
                    ))
                )}
            </select>
        </div>
    );
};

export default TintedDesign;
